import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import logo from './logo-full.svg';
import './HarleyDavidsonSmallLogo.css';
import { useIwaContext } from '@cognitranlimited/itis-web';
export var HarleyDavidsonSmallLogo = function () {
    var strings = useIwaContext().strings;
    return _jsx("img", { className: "HarleyDavidsonSmallLogo", src: logo, alt: strings.app.name });
};
